module.exports = __webpack_public_path__ + "img/samsung-logo.827a8454.png";